import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import useUserStore from "../../storeModules/useUserStore";
import {
  basicNameRegex,
  nomeRazaoRegex,
  allRepeatedNumbersRegex,
  logradouroRegex,
  bairroRegex,
} from "../../utils/regex";
import InputMessage from "./inputMessage";
import { NumericFormat, PatternFormat } from "react-number-format";
import useBotControlStore from "../../storeModules/useBotControlStore";
import useInitialConfigStore from "../../storeModules/useInitialConfigStore";
import steps from "../../screens/bot/stepModules/steps";
import isEmail from "../../utils/isEmail";
import capitalizeFirstCharOfSegments from "../../utils/capitalizeFirstCharOfSegments";
import validateCnpj from "../../utils/validateCnpj";
import { cpf, cnpj } from "cpf-cnpj-validator";
import removeSpecialCharacters from "../../utils/removeSpecialCharacters";
import removeMoneyMask from "../../utils/removeMoneyMask";
import addMoneyMask from "../../utils/addMoneyMask";
import addPhoneMask from "../../utils/addPhoneMask";
import addCepMask from "../../utils/addCepMask";
import useConsorcioStore from "../../storeModules/useConsorcioStore";
import { validateContractDate } from "../../utils/contractDateValidation";
import removeLastTwoDigits from "../../utils/removeLastTwoDigits";
import findStep from "../../screens/bot/stepModules/findStep";
import sleepAwait from "../../utils/sleepAwait";
import trackConversacaoStep from "../../utils/trackConversacaoStep";
import preventDoubleClick from "../../utils/preventDoubleClick";
import LoadingSpinner from "../loadingSpinner";
import { getInputMobileType } from "./getInputMobileType";
import InputMask from "react-input-mask";
import InternationalPhoneInput from "../../components/internationalPhoneInput";
import { PhoneNumberUtil } from "google-libphonenumber";

const BotInput = ({ inputType, submitAction }) => {
  if (typeof inputType === "function") {
    inputType = inputType();
  }

  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const currentStep = useBotControlStore((state) => state.currentStep);

  const { inputs } = useInitialConfigStore.getState((state) => state).theme;
  const phoneUtil = PhoneNumberUtil.getInstance();

  const {
    basicUserName,
    userCredit,
    userRendaMensal,
    userRendaExtra,
    userEmail,
    userTelefone,
  } = useUserStore((state) => state.basic);

  const {
    userNomeRazao,
    tipoPessoa,
    cpfCnpj,
    cep,
    nascimentoFundacao,
    logradouro,
    bairro,
  } = useUserStore((state) => state.contrato);

  const { setUserBasicInfo, setUserContratoInfo, setUserCupom, userCupom, pesquisa } =
    useUserStore((state) => state);

  const { setMessages, couponErrorMessage } = useBotControlStore(
    (state) => state,
  );

  const isPessoaFisica = tipoPessoa === 0;

  const fakeLoad = useInitialConfigStore.getState().fakeLoad;

  const createTitle = (value) => {
    let messageTitle = "";

    if (inputProps[inputType].hasDisplayTitle) {
      messageTitle = value;
    }

    return messageTitle;
  };

  const createTextMessage = (text) => {
    let textMessage = text;

    if (
      inputProps[inputType].name === "userCreditValue" ||
      inputProps[inputType].name === "userRendaMensal" ||
      inputProps[inputType].name === "userRendaExtra"
    ) {
      textMessage = addMoneyMask(removeLastTwoDigits(text));
    }

    if (inputProps[inputType].name === "userTelefone") {
      textMessage = text;
    }

    if (inputProps[inputType].name === "userCep") {
      textMessage = addCepMask(text);
    }

    return textMessage;
  };

  const {
    handleSubmit,
    formState: { errors },
    getValues,
    control,
    formState,
    setError,
    trigger,
    setValue,
    // watch,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      userBasicName: "",
    },
  });

  useEffect(() => {
    if (inputProps[inputType].value) {
      setValue(inputProps[inputType].name, inputProps[inputType].value);
      trigger(inputProps[inputType].name);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Seta o erro do cupom que deve ser mostrado em tela
  useEffect(() => {
    if (!!couponErrorMessage) {
      setError("userCupom", {
        type: "custom",
        message: couponErrorMessage,
      });
    } else {
      delete errors.userCupom;
    }
  }, [couponErrorMessage, errors.userCupom, setError]);

  // watch((values) => {
  //   console.log(values);
  //   console.log("errors: ", errors);
  // });

  const onSubmit = async () => {
    if (isButtonLoading) {
      return;
    }

    const hasNameValidation =
      steps[currentStep].action &&
      (inputProps[inputType].name === "userBasicName" ||
        inputProps[inputType].name === "userContratoNomeRazao" ||
        inputProps[inputType].name === "userEmail");

    if (hasNameValidation) {
      setIsButtonLoading(true);
      const response = await submitAction();

      await sleepAwait(fakeLoad / 2);
      setIsButtonLoading(false);

      if (response && !response.success) {
        setError(response.inputType, {
          type: "custom",
          message: response.errorMessage,
        });
      } else {
        await trackConversacaoStep({
          stepName: steps[currentStep].name,
          userMessage: createTextMessage(getValues(inputProps[inputType].name)),
          userOnly: true,
        });
        setMessages({
          sender: "user",
          text: createTextMessage(getValues(inputProps[inputType].name)),
          title: createTitle(getValues(inputProps[inputType].name)),
        });

        if (response && response.nextStep) {
          useBotControlStore.setState({
            currentStep: findStep(response.nextStep).index,
          });
        }
      }
    } else {
      await trackConversacaoStep({
        stepName: steps[currentStep].name,
        userMessage: createTextMessage(getValues(inputProps[inputType].name)),
        userOnly: true,
      });
      setMessages({
        sender: "user",
        text: createTextMessage(getValues(inputProps[inputType].name)),
        title: createTitle(getValues(inputProps[inputType].name)),
      });

      steps[currentStep].action();
    }
  };

  const inputProps = {
    userBasicName: {
      name: "userBasicName",
      rules: {
        required: {
          value: true,
          message: "Preencha para continuar! 😊",
        },
        validate: {
          value: (value) => {
            return basicNameRegex.test(value) || "Está correto? 🤔";
          },
        },
      },
      mask: "",
      change: (value) => {
        const capitalizedName = capitalizeFirstCharOfSegments(value);
        setUserBasicInfo(capitalizedName, "nome");
        return capitalizedName;
      },
      value: basicUserName,
      inputStyle: "text",
      mobileKeyboardType: "text",
    },
    userCreditValue: {
      name: "userCreditValue",
      rules: {
        required: {
          value: true,
          message: "Preencha para continuar! 😊",
        },
        validate: {},
        min: {
          value: useConsorcioStore.getState().ranges.minBemValor * 100,
          message: `O crédito mínimo é de ${addMoneyMask(
            useConsorcioStore.getState().ranges.minBemValor,
          )}`,
        },
        max: {
          value: useConsorcioStore.getState().ranges.maxBemValor * 100,
          message: `O crédito máximo é de ${addMoneyMask(
            useConsorcioStore.getState().ranges.maxBemValor,
          )}`,
        },
      },
      format: "",
      change: (value) => {
        const cleanValue = removeMoneyMask(value);
        setUserBasicInfo(removeLastTwoDigits(cleanValue), "valorCredito");
        return cleanValue || 0;
      },
      value: userCredit,
      inputStyle: "money",
      mobileKeyboardType: "numeric",
    },
    userRendaMensal: {
      name: "userRendaMensal",
      rules: {
        required: {
          value: true,
          message: "Preencha para continuar! 😊",
        },
        validate: {},
        min: {
          value: 10000,
          message: "Valor inválido",
        },
      },
      format: "",
      change: (value) => {
        const cleanValue = removeMoneyMask(value);
        setUserBasicInfo(removeLastTwoDigits(cleanValue), "rendaMensal");
        return cleanValue || 0;
      },
      value: userRendaMensal,
      inputStyle: "money",
      mobileKeyboardType: "numeric",
    },
    userRendaExtra: {
      name: "userRendaExtra",
      rules: {
        required: {
          value: true,
          message: "Preencha para continuar! 😊",
        },
        validate: {},
        min: {
          value: 10000,
          message: "Valor inválido",
        },
      },
      format: "",
      change: (value) => {
        const cleanValue = removeMoneyMask(value);
        setUserBasicInfo(removeLastTwoDigits(cleanValue), "rendaExtra");
        return cleanValue || 0;
      },
      value: userRendaExtra,
      inputStyle: "money",
      mobileKeyboardType: "numeric",
    },
    userEmail: {
      name: "userEmail",
      rules: {
        required: {
          value: true,
          message: "Preencha para continuar! 😊",
        },
        validate: {
          value: (value) => isEmail(value) || "E-mail inválido 🤔",
        },
        maxLength: {
          value: 60,
          message: "Numero máximo de caracteres excedido",
        },
      },
      format: "",
      change: (value) => {
        setUserBasicInfo(value, "email");
        return value;
      },
      value: userEmail,
      inputStyle: "text",
      hasDisplayTitle: true,
      mobileKeyboardType: "text",
    },
    userTelefone: {
      name: "userTelefone",
      rules: {
        required: {
          value: true,
          message: "Preencha para continuar! 😊",
        },
        validate: {
          minSize: (number) => {
            const onlyNumbers = number.replace(/\D/g, "");
            return onlyNumbers.length >= 13 || "Telefone inválido 🤔";
          },
          validPhoneNumber: (number) => {
            return (
              phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(number)) ||
              "Telefone inválido 🤔"
            );
          },
        },
      },
      format: "",
      mask: "",
      change: (inputValue, country) => {
        setUserBasicInfo(inputValue, "telefone");
        return inputValue;
      },
      value: userTelefone,
      inputStyle: "internationalPhoneInput",
      mobileKeyboardType: "numeric",
    },
    userContratoNomeRazao: {
      name: "userContratoNomeRazao",
      rules: {
        required: {
          value: true,
          message: "Preencha para continuar! 😊",
        },
        validate: {
          value: (value) => {
            const nomeTitularErrorMessage = isPessoaFisica
              ? "Nome inválido"
              : "Razão Social inválida";

            return nomeRazaoRegex.test(value) || nomeTitularErrorMessage;
          },
        },
        maxLength: {
          value: 30,
          message: "Numero máximo de caracteres excedido 🤔",
        },
      },
      mask: "",
      change: (value) => {
        const capitalizedName = capitalizeFirstCharOfSegments(value);
        setUserContratoInfo(capitalizedName, "nomeRazao");
        return capitalizedName;
      },
      value: userNomeRazao,
      inputStyle: "text",
      mobileKeyboardType: "text",
    },
    userCpfCnpj: {
      name: "userCpfCnpj",
      rules: {
        required: { value: true, message: "Preencha para continuar! 😊" },
        validate: {
          value: (value) => {
            const cleanValue = removeSpecialCharacters(value);
            if (isPessoaFisica) {
              return (cleanValue && cpf.isValid(cleanValue)) || "CPF inválido";
            }

            return (value && cnpj.isValid(cleanValue)) || "CNPJ inválido";
          },
        },
      },
      format: isPessoaFisica ? "###.###.###-##" : "##.###.###/####-##",
      mask: "_",
      change: (value) => {
        setUserContratoInfo(value, "cpfCnpj");
        return value;
      },
      value: cpfCnpj,
      inputStyle: "mask",
      mobileKeyboardType: "numeric",
    },
    userCpf: {
      name: "userCpf",
      rules: {
        required: { value: true, message: "Preencha para continuar! 😊" },
        validate: {
          value: (value) => {
            const cleanValue = removeSpecialCharacters(value);
            if (isPessoaFisica) {
              return (cleanValue && cpf.isValid(cleanValue)) || "CPF inválido";
            }

            return (value && validateCnpj(cleanValue)) || "CNPJ inválido";
          },
        },
      },
      format: isPessoaFisica ? "###.###.###-##" : "##.###.###/####-##",
      mask: "_",
      change: (value) => {
        setUserContratoInfo(value, "cpfCnpj");
        return value;
      },
      value: cpfCnpj,
      inputStyle: "mask",
      mobileKeyboardType: "numeric",
    },
    userCnpj: {
      name: "userCnpj",
      rules: {
        required: { value: true, message: "Preencha para continuar! 😊" },
        validate: {
          value: (value) => {
            const cleanValue = removeSpecialCharacters(value);
            return (value && validateCnpj(cleanValue)) || "CNPJ inválido";
          },
        },
      },
      format: "**.***.***/****-99",
      mask: "_",
      change: (value) => {
        const upperCaseValue = value.toUpperCase();
        setUserContratoInfo(upperCaseValue, "cpfCnpj");
        return upperCaseValue;
      },
      value: cpfCnpj,
      inputStyle: "text-mask",
      mobileKeyboardType: "text",
    },
    userCep: {
      name: "userCep",
      rules: {
        required: { value: true, message: "Preencha para continuar! 😊" },
        validate: {
          value: (value) => {
            const cleanValue = removeSpecialCharacters(value);
            return allRepeatedNumbersRegex.test(cleanValue) || "CEP inválido";
          },
        },
      },
      format: "#####-###",
      mask: "_",
      change: (value) => {
        const cleanValue = removeSpecialCharacters(value);
        setUserContratoInfo(cleanValue, "cep");
        return cleanValue;
      },
      value: cep,
      inputStyle: "mask",
      mobileKeyboardType: "numeric",
    },
    userNascimentoFundacao: {
      name: "userNascimentoFundacao",
      rules: {
        validate: {
          value: (value) => {
            const result = validateContractDate({ value, isPessoaFisica });
            return result.valid || result.message;
          },
        },
      },
      format: "##/##/####",
      mask: "_",
      change: (value) => {
        setUserContratoInfo(value, "nascimentoFundacao");

        if (value === "__/__/____") {
          return "";
        } else {
          return value;
        }
      },
      value: nascimentoFundacao,
      inputStyle: "mask",
      mobileKeyboardType: "numeric",
    },
    userStreet: {
      name: "userStreet",
      rules: {
        required: { value: true, message: "Preencha para continuar! 😊" },
        maxLength: {
          value: 60,
          message: "Numero máximo de caracteres excedido",
        },
        validate: {
          value: (value) => {
            const cleanValue = value.trim();
            return logradouroRegex.test(cleanValue) || "Está correto? 🤔";
          },
        },
      },
      change: (value) => {
        setUserContratoInfo(value, "logradouro");
        return value;
      },
      value: logradouro,
      inputStyle: "text",
      mobileKeyboardType: "numeric",
    },
    userNeighborhood: {
      name: "userNeighborhood",
      rules: {
        required: { value: true, message: "Preencha para continuar! 😊" },
        maxLength: {
          value: 40,
          message: "Numero máximo de caracteres excedido",
        },
        validate: {
          value: (value) => {
            const cleanValue = value.trim();
            return bairroRegex.test(cleanValue) || "Está correto? 🤔";
          },
        },
      },
      change: (value) => {
        setUserContratoInfo(value, "bairro");
        return value;
      },
      value: bairro,
      inputStyle: "text",
      mobileKeyboardType: "text",
    },
    userCupom: {
      name: "userCupom",
      rules: {},
      mask: "",
      change: (value) => {
        const uppercaseValue = value.toUpperCase();
        setUserCupom(uppercaseValue);

        return uppercaseValue;
      },
      value: userCupom,
      inputStyle: "text",
      mobileKeyboardType: "text",
    },
    userPesquisaComentarios: {
      name: "userPesquisaComentarios",
      rules: {
        required: { value: true, message: "Preencha para continuar! 😊" },
      },
      change: (value) => {
        useUserStore.setState((state) => ({
          ...state,
          pesquisa: { ...state.pesquisa, comentarios: value },
        }));
        return value;
      },
      value: pesquisa?.comentarios || "",
      inputStyle: "text",
      mobileKeyboardType: "text",
    },
  };

  return (
    <>
      <div
        data-testid={`bot-input-container`}
        className={`input-container ${
          errors[inputType] ? "input-container__error" : ""
        }`}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Controller
            control={control}
            name={inputProps[inputType].name}
            rules={inputProps[inputType].rules}
            render={({ field: { onChange, onBlur } }) => (
              <>
                {inputProps[inputType].inputStyle === "text" && (
                  <input
                    autoComplete="off"
                    data-testid={`bot-input-${inputType}`}
                    style={{
                      borderColor: inputs.backgroundColor,
                    }}
                    autoFocus
                    mask={inputProps[inputType].mask}
                    onBlur={onBlur}
                    onChange={(e) => {
                      onChange(inputProps[inputType].change(e.target.value));
                    }}
                    value={inputProps[inputType].value}
                    type="text"
                    placeholder="Escreva aqui..."
                    inputMode={getInputMobileType(
                      inputProps[inputType].mobileKeyboardType,
                    )}
                  />
                )}

                {inputProps[inputType].inputStyle === "money" && (
                  <NumericFormat
                    autoComplete="off"
                    data-testid={`bot-input-${inputType}`}
                    style={{
                      borderColor: inputs.backgroundColor,
                    }}
                    autoFocus
                    value={inputProps[inputType].value}
                    thousandSeparator="."
                    decimalSeparator=","
                    allowNegative={false}
                    decimalScale={2}
                    fixedDecimalScale
                    prefix={"R$ "}
                    onChange={(e) => {
                      onChange(inputProps[inputType].change(e.target.value));
                    }}
                    placeholder="Escreva aqui..."
                    inputMode={getInputMobileType(
                      inputProps[inputType].mobileKeyboardType,
                    )}
                  />
                )}

                {inputProps[inputType].inputStyle === "mask" && (
                  <PatternFormat
                    autoComplete="off"
                    data-testid={`bot-input-${inputType}`}
                    style={{
                      borderColor: inputs.backgroundColor,
                    }}
                    autoFocus
                    format={inputProps[inputType].format}
                    mask={inputProps[inputType].mask}
                    allowEmptyFormatting
                    onChange={(e) => {
                      onChange(inputProps[inputType].change(e.target.value));
                    }}
                    value={inputProps[inputType].value}
                    inputMode={getInputMobileType(
                      inputProps[inputType].mobileKeyboardType,
                    )}
                  />
                )}

                {inputProps[inputType].inputStyle === "text-mask" && (
                  <InputMask
                    data-testid={`bot-input-${inputProps[inputType].name}`}
                    mask={inputProps[inputType].format}
                    maskChar="_"
                    value={inputProps[inputType].value}
                    onChange={(e) => {
                      onChange(inputProps[inputType].change(e.target.value));
                    }}
                  />
                )}

                {inputProps[inputType].inputStyle ===
                  "internationalPhoneInput" && (
                  <InternationalPhoneInput
                    testid={`bot-input-${inputProps[inputType].name}`}
                    value={inputProps[inputType].value}
                    onChange={(inputValue, country) => {
                      onChange(
                        inputProps[inputType].change(inputValue, country),
                      );
                    }}
                    hasError={!!errors[inputType]}
                  />
                )}
              </>
            )}
          />
          <span
            role="button"
            className={`input-arrow
              ${
                formState.isValid && !isButtonLoading
                  ? ""
                  : "input-arrow__disabled"
              }
              ${
                (steps[currentStep].name === "informa_codigo_cupom" ||
                  steps[currentStep].name === "tentar_cupom_novamente") &&
                userCupom.length === 0
                  ? "input-arrow__disabled"
                  : ""
              }`}
            onClick={() => preventDoubleClick(onSubmit)}
          >
            {isButtonLoading ? (
              <LoadingSpinner color={inputs.backgroundColor} />
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                style={{ fill: inputs.backgroundColor }}
              >
                <path d="M1.1 21.757l22.7-9.73L1.1 2.3l.012 7.912 13.623 1.816-13.623 1.817-.01 7.912z"></path>
              </svg>
            )}
          </span>
        </form>
      </div>
      <InputMessage errors={errors} inputType={inputType} />
    </>
  );
};

export default BotInput;
